"use client";

import { useEffect, useRef } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { trackEvent } from '@/lib/analytics';

export default function PageViewTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const lastTrackedPath = useRef<string | null>(null);

  useEffect(() => {
    if (!pathname) return;
    
    const queryString = searchParams?.toString();
    const fullPath = queryString ? `${pathname}?${queryString}` : pathname;

    // Prevent duplicate tracks for same path in React Strict Mode
    if (lastTrackedPath.current === fullPath) return;
    lastTrackedPath.current = fullPath;

    // Detect tool from URL
    let tool: string | undefined = undefined;
    if (pathname.includes('/compress-pdf')) {
      tool = 'compress';
    } else if (pathname.includes('/merge-pdf')) {
      tool = 'merge';
    } else if (pathname.includes('/split-pdf')) {
      tool = 'split';
    }

    trackEvent('page_view', {
      tool: tool,
      page: fullPath,
    });
  }, [pathname, searchParams]);

  return null;
}
